const languageList = [
    {
        label: 'English',
        value: 'en'
    },
    {
        label: 'French',
        value: 'fr',
    }
]

export default languageList
